<template>
  <div class="ueditor-container" style="position: relative">
    <i class="insertImgx" @click="onPic"></i>
    <i class="insertVideox" @click="onVideo"></i>
    <div v-show="checked" :id="editorId" class="ueditor-content"></div>
  </div>
</template>
<script>
export default {
  name: "uEditorTool",
  props: {
    content: "",
    checked: false,
    name: "",
  },
  data() {
    return {
      fullscreen: false,
      ueditor: null,
    };
  },
  computed: {
    editorId() {
      return `uedittor_id_${this.name || new Date().valueOf()}`;
    },
    html() {
      return this.ueditor ? this.ueditor.getContent() : "";
    },
  },
  watch: {
    content: {
      handler(n) {
        this.setUeditor(n);
      },
      immediate: true,
    },
  },
  mounted() {},
  /**
   * ⚠ 必须销毁，否则同一个 editorId 第二次挂载时编辑框是**一片空白**。
   *
   * UEditor 的实例是全局缓存的（ueditor.all.js:20008）：
   *   UE.getEditor = function (id, opt) {
   *     var editor = instances[id];
   *     if (!editor) { editor = instances[id] = new UE.ui.Editor(opt); editor.render(id) }
   *     return editor;   // 命中缓存就直接返回，不会 render 到新的 DOM 上
   *   }
   * 而 render 是往容器里 appendChild、不清空容器。
   *
   * 所以组件被 v-if 销毁后 DOM 没了、instances[id] 还在；再挂回来时 getEditor
   * 返回那个 DOM 已被摘掉的旧实例、不 render，新容器里什么都没有。内容其实还在
   * 旧实例里（getContent 取得到），但运营当场没法编辑。
   *
   * 这个仓从来没人调过 delEditor —— 用到本组件的 19 个页面都是"挂一次就跳走"，
   * 碰不到第二次挂载，所以一直没暴露。自定义活动页的搭建器是第一个会在同一个
   * 页面里反复切换富文本组件的地方。
   *
   * delEditor 自身是安全的（ueditor.all.js:20018 先判存在、再 destroy、再删缓存），
   * 外面再包一层 try/catch：销毁失败不该连累"离开页面"这件事。
   */
  beforeDestroy() {
    clearTimeout(this.time);
    try {
      if (typeof UE !== "undefined" && UE.delEditor) UE.delEditor(this.editorId);
    } catch (e) {
      // 销毁失败就算了
    }
    this.ueditor = null;
  },
  methods: {
    setUeditor(html) {
      clearTimeout(this.time);
      this.time = setTimeout(() => {
        this.fullscreen = false;

        const options = {
          lang: "zh-cn",
          initialFrameWidth: null,
          autoHeightEnabled: false,
        };
        const ue = UE.getEditor(this.editorId, options);
        this.ueditor = ue;
        ue.ready(function () {
          ue.setHeight(500);
          ue.setContent(html);
        });
      }, 200);
    },
    onPic() {
      this.$emit("pic", this.ueditor);
    },
    onVideo() {
      this.$emit("video", this.ueditor);
    },
    insertHtml(html) {
      this.ueditor.execCommand("insertHtml", html);
    },
    insertImage(option = {}) {
      this.ueditor.execCommand("insertimage", option);
    },
    insertVideo(option = {}) {
      this.ueditor.execCommand("insertvideo", option);
    },
  },
};
</script>
<style scoped>
::v-deep .edui-default .edui-for-nimages .edui-icon {
  background-position: -726px -77px;
}
::v-deep .edui-default .edui-for-nvideo .edui-icon {
  background-position: -320px -20px;
}
::v-deep .edui-default.edui-toolbar {
  line-height: normal !important;
}
.ueditor-container {
  width: 1067px;
  position: relative;
}
.ueditor-container .insertImgx {
  position: absolute;
  top: 30px;
  right: 660px;
  z-index: 1000;
  width: 20px;
  height: 20px;
}

.ueditor-container .insertVideox {
  position: absolute;
  top: 30px;
  right: 634px;
  z-index: 1000;
  width: 20px;
  height: 20px;
}

.ueditor-content {
  position: relative;
  margin-bottom: 8px;
  margin-top: 4px;
}
</style>
